import { trackUserInteraction } from 'actions/tracking';
import { formatPrice } from 'helpers';
import { useDispatch, useHistory, useSelector } from 'hooks';
import { Text, Flex } from 'mymoria-ui/components';
import React, { FunctionComponent } from 'react';
import { useRouteMatch } from 'react-router-dom';

interface FavoriteProductsItemProps {
  sku: string;
}

const FavoriteProductsItem: FunctionComponent<FavoriteProductsItemProps> = ({ sku }) => {
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const { push } = useHistory();

  const handleClick = (category: string, shortname: string, sku: string) => {
    dispatch(trackUserInteraction('Product Details', shortname));
    push(`${url}/products/${category}/${sku}`);
  };

  const favoriteProduct = useSelector(({ entities }) => entities.products[sku]);

  if (!favoriteProduct) {
    return null;
  }

  const {
    translations: { shortname },
    category,
    pictures,
    price,
  } = favoriteProduct;

  return (
    <Flex
      className="col"
      width={1}
      flexDirection="column"
      display="flex"
      onClick={() => handleClick(category, shortname, sku)}
    >
      <img src={`${pictures[0]}?width=300&height=200`} alt={shortname} />
      <Text fontWeight="extraBold" fontSize="extraLarge">
        {formatPrice(price)}
      </Text>
      <Text>{shortname}</Text>
    </Flex>
  );
};

export default FavoriteProductsItem;
